import styles from './PatientLinks.module.scss';
import { PatientLink } from './components/PatientLink/PatientLink';
import cx from 'classnames';
import { Icon, RolePermissionChecker, Text } from 'components';
import { appActions } from 'store/app/slice';
import { useDispatch } from 'store/utils';
import { TreatmentPlanTask, UserRole } from 'types';

type Props = {
  scan3dLinks: string[];
  letterLinks: string[];
  otherLinks: string[];
  task: TreatmentPlanTask;
  isBlocked: boolean;
};

const allowToEditTask = [
  TreatmentPlanTask.LETTER_TO_DO,
  TreatmentPlanTask.LETTER_SUBMITTED,
  TreatmentPlanTask.LETTER_SENT,
  TreatmentPlanTask.DIAGNOSIS_SUBMITTED,
  TreatmentPlanTask.DIAGNOSIS_TO_DO,
  TreatmentPlanTask.TO_SUBMIT,
];

export const PatientLinks = ({ scan3dLinks, letterLinks, otherLinks, task, isBlocked }: Props) => {
  const dispatch = useDispatch();

  const openModal = () => {
    dispatch(appActions.setIsModalOpened({ name: 'addPatientLinks', isOpened: true }));
  };

  const isHasLinks = letterLinks.length || scan3dLinks.length || otherLinks.length;

  const isAllowedToEdit = !isBlocked && allowToEditTask.includes(task);

  return (
    <div className={styles.wrapper}>
      <div className={styles.titleWrapper}>
        <div className={styles.titleBlock}>
          <Text type="overline" className={styles.upperCaseText}>
            Links
          </Text>
          <Text type="caption" className={styles.textNotSet}>
            Please provide 3d scan, letter and other links
          </Text>
        </div>
        {isAllowedToEdit && (
          <RolePermissionChecker rolesAllowedToView={[UserRole.CLINIC]}>
            <div className={cx(styles.iconWrapper, { [styles.white]: !!isHasLinks })} onClick={openModal}>
              {<Icon name={isHasLinks ? 'Edit' : 'Plus'} />}
            </div>
          </RolePermissionChecker>
        )}
      </div>
      {scan3dLinks.length > 0 && (
        <div className={styles.linksWrapper}>
          <Text type="subtitle2">Intraoral 3d scan</Text>
          <div className={styles.linksBlock}>
            {scan3dLinks.map((link) => (
              <PatientLink link={link} key={link} />
            ))}
          </div>
        </div>
      )}
      {letterLinks.length > 0 && (
        <div className={styles.linksWrapper}>
          <Text type="subtitle2">Letter</Text>
          <div className={styles.linksBlock}>
            {letterLinks.map((link) => (
              <PatientLink link={link} key={link} />
            ))}
          </div>
        </div>
      )}
      {otherLinks.length > 0 && (
        <div className={styles.linksWrapper}>
          <Text type="subtitle2">Other</Text>
          <div className={styles.linksBlock}>
            {otherLinks.map((link) => (
              <PatientLink link={link} key={link} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
